<template>
    <v-container class="m-0 p-0">
        <v-row  v-for="(field, index) in fields" :key="index">
            <v-col cols="8" sm="8">
                <v-text-field
                        v-model="fields[index]"
                        :label="label"
                ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" class="pt-6 text-end">
                <v-btn v-if="index !== fields.length - 1" @click="removeField(index)">
                    <span class="text-xl-h5">-</span>
                </v-btn>
                <v-btn v-else color="primary" @click="addField">
                    <span class="text-xl-h5">+</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'Field',
            },
            value: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                fields: [...this.value],
            };
        },
        watch: {
            fields: {
                handler(newValue) {
                    if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
                        this.$emit('input', newValue);
                    }
                },
                deep: true,
            },
            value(newValue) {
                this.fields = [...newValue];
            },
        },
        computed: {
            canAddField() {
                return this.fields.length === 0 || this.fields[this.fields.length - 1] !== '';
            }
        },
        methods: {
            addField() {
                if (!this.canAddField) {
                    return;
                }
                this.fields.push('');
                this.$emit('input', this.fields);
            },
            removeField(index) {
                console.log(index);
                this.fields.splice(index, 1);
                this.$emit('input', this.fields);
            }
        },
    };
</script>
